import { z } from 'zod'

const environmentSchema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
})

const parsedEnvironment = environmentSchema.parse(import.meta.env)

export const environment = {
  apiBaseUrl: parsedEnvironment.VITE_API_BASE_URL,
} as const
